import { render } from "./EditProprietarioPage.vue?vue&type=template&id=6db54100"
import script from "./EditProprietarioPage.vue?vue&type=script&lang=js"
export * from "./EditProprietarioPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__